import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import translate from '../../../commonComponents/translate';
import ProductVariationsProp from '../propTypes/productVariationsProp';
import CircleMinusIcon from '../../../commonComponents/icons/CircleMinusIcon';
import CirclePlusIcon from '../../../commonComponents/icons/CirclePlusIcon';

function ShopProductVariationQuantity(props) {
  const {
    t,
    index,
    handleChange,
    variation,
    currentVariation,
    isTouched,
    showLabel,
    hideMinusButtonThreshold,
  } = props;

  return (
    <div className="quantity">
      {showLabel ? (
        <label
          htmlFor={`quantity-${index}`}
          className="col-form-label fix-column-label pr-2"
        >
          {`${t('shop.product.qty')}:`}
        </label>
      ) : null}
      <div className="quantity-amount">
        <div className="button-width">
          <button
            className={cx('quantity-button', 'minus-button', {
              'd-none': currentVariation.amount === hideMinusButtonThreshold,
            })}
            type="button"
            onClick={() => handleChange('minus')}
          >
            <CircleMinusIcon />
          </button>
        </div>
        <div className="input-wrapper">
          <span
            data-testid={`variation-input-${index}`}
            id={`quantity-${variation._id}`}
            className="input-quantity"
          >
            {isTouched && currentVariation.amount >= 0
              ? currentVariation.amount
              : 0}
          </span>
        </div>
        <div className="button-width">
          <button
            className="quantity-button plus-button"
            type="button"
            onClick={() => handleChange('plus')}
          >
            <CirclePlusIcon />
          </button>
        </div>
      </div>
    </div>
  );
}

ShopProductVariationQuantity.propTypes = {
  t: PropTypes.func.isRequired,
  index: PropTypes.number,
  handleChange: PropTypes.func.isRequired,
  variation: PropTypes.shape(ProductVariationsProp.propType).isRequired,
  currentVariation: PropTypes.shape(ProductVariationsProp.propType).isRequired,
  isTouched: PropTypes.bool.isRequired,
  showLabel: PropTypes.bool,
  hideMinusButtonThreshold: PropTypes.number,
};

ShopProductVariationQuantity.defaultProps = {
  index: 0,
  showLabel: true,
  hideMinusButtonThreshold: 0,
};

export default translate(ShopProductVariationQuantity);
